<template>
  <div class="modal_clients">
    <div class="modal_clients__header">
      <h4 class="title">
        {{ translate("client.new_client") }}
      </h4>
    </div>
    <div class="modal_clients__body">
      <div class="block_wrap">
        <div class="row">
          <div class="col-md-5">
            <fg-input
                v-model="main_info.name"
                type="text"
                :label="translate('client.main_info.name')"
            />
          </div>
          <div class="col-md-5">
            <label>
              {{ translate('client.parent_company') }}
            </label>
            <tree-select
                :options="client_list"
                :placeholder="translate('client.parent_company')"
                v-model="main_info.parent_client_id"
                :clearable="false"
                :multiple="false"
                :disabled="!this.$store.getters.getPermissions.editClientParent === true"
            />
          </div>
          <div class="col-md-2">
            <label>
              {{ translate('client.main_info.edo_type') }}
            </label>
            <tree-select
                :options="edo_list"
                :placeholder="translate('client.main_info.edo_type')"
                v-model="main_info.edo_id"
                :clearable="false"
                :multiple="false"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input
                v-model="main_info.ur_name"
                type="text"
                :label="translate('client.main_info.ur_name')"
            />
          </div>
          <div class="col-md-4">
            <fg-input
                v-model="main_info.city"
                type="text"
                :label="translate('client.main_info.city')"
            />
          </div>
          <div class="col-md-4">
            <fg-input
                v-model="main_info.inn"
                type="text"
                :label="translate('client.main_info.inn')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input
                v-model="main_info.monthly_traffic_cost_limit"
                type="number"
                :label="translate('client.settings.monthly_traffic_cost_limit')"
                :readonly="false"
            />
          </div>

          <div class="col-md-4">
            <div class="filter checkbox" @click.prevent="new_device_group = !new_device_group">
              <div class="info">
                {{ translate('client.new_device_group') }}
              </div>
              <label class="switch">
                <input type="checkbox" v-model="new_device_group">
                <span class="slider round"></span>
              </label>
            </div>
          </div>


          <div class="col-md-4">
            <div class="filter checkbox" @click.prevent="new_device_simcard_group = !new_device_simcard_group">
              <div class="info">
                {{ translate('client.new_device_simcard_group') }}
              </div>
              <label class="switch">
                <input type="checkbox" v-model="new_device_simcard_group">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text_wrap">
            <div class="form-group">
              <label>{{ translate('client.main_info.descr') }}</label>
              <textarea class="input_text" name="name" v-model="main_info.descr"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_clients__footer text-center">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="save_client"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>

</template>
<script>

export default {
  name: 'AddClient',

  data () {
    return {
      main_info: {},
      active: true,
      use_diadoc: false,
      new_device_group: true,
      new_device_simcard_group: false
    }
  },
  computed:{
    edo_list(){
      return this.$store.getters.getClientEdoSystems.map((system) => {
        return { id: system.id, label: system.title }
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        if (client.active !== 0){
          return { id: client.id, label: client.name }
        }
      }).filter((element) => { return element !== undefined })
    },
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    save_client(){
      this.main_info.active  = this.active ? 1 : 0
      this.main_info.use_diadoc = this.use_diadoc ? 1 : 0
      this.main_info.create_device_group = this.new_device_group ? 1 : 0
      this.main_info.create_device_simcard_group = this.new_device_simcard_group ? 1 : 0
      this.main_info.monthly_traffic_cost_limit = Number(this.main_info.monthly_traffic_cost_limit)

      this.$http.v1.createClient(this.main_info, (response) => {
        this.global_notify('info', this.translate('client.saved_success'))
        this.$store.dispatch('clientsListUpdate')

        if (this.new_group) {
          this.$store.dispatch('deviceGroupUpdate')
        }
        this.$emit('close')
        this.$router.push({path: '/client/' + response.data.id})
      })
    }
  }
}

</script>

<style lang='scss' scoped>

.modal_clients{
  height: 100%;
  padding: 10px;
  &__header{
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    .title{
      width: 100%;
      margin: 0;
      text-align: center;
    }
    .links{
      width: 30%;
      & > .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }
  &__body{
    width: 100%;
  }
  &__footer{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    button{
      margin: 0;
    }
  }
}



</style>

